<template>
  <div class="amount">
    <div class="input-group bootstrap-touchspin">
    <span class="input-group-btn">
      <button @click="amount--" class="btn btn-default bootstrap-touchspin-down" type="button">-</button>
    </span>
      <span class="input-group-addon bootstrap-touchspin-prefix" style="display: none;"></span>
      <input type="tel" v-model="amount" v-bind:min="minValue" name="touchspinInput" class="touchSpinInput form-control"
             style="display: block;">
      <span class="input-group-addon bootstrap-touchspin-postfix" style="display: none;"></span>
      <span class="input-group-btn">
      <button @click="amount++" class="btn btn-default bootstrap-touchspin-up" type="button">+</button>
    </span>
    </div>
  </div>
</template>

<script>
import TypeHelper from '../../../../../model/helper/TypeHelper'

export default {
  props: {
    formData:   {
      type:    Object,
      default: function () {
        return null
      }
    },
    elementDef: {
      type:    Object,
      default: function () {
        return null
      }
    }
  },

  data () {
    return {
      amount:   0,
      minValue: 1
    }
  },

  created () {
    this._setAmount()
  },

  watch: {
    'amount':   function (value) {
      if ((value < this.minValue) || (!TypeHelper.isNumeric(value))) {
        this.amount = 1
        return
      }

      this.$emit('change', { value: value, key: this.elementDef.Field })
    },
    'formData': function () {
      this._setAmount()
    }
  },

  methods: {
    /**
     *
     * @private
     */
    _setAmount () {
      this.amount = this.formData[this.elementDef.ColumnName]
    }
  }
}
</script>

<style scoped>

</style>
